<!--单个视频播放组件-->

<template>
  <div style="width: 100%; height: 100%">
    <video class="video-play" :id="videoPlayer.videoId" autoplay :muted="isMuted"></video>
    <canvas :id="videoPlayer.canvasId" style="display: none" width="515" height="300"></canvas>
  </div>
</template>
<script>
import flvjs from "flv.js";
import settings from "@/settings";
export default {
  name: "VideoPlay",
  props: ["videoPlayer"],
  data() {
    return {
      isMuted: true,
      flvPlayer: null,
      reconnectTimeout: null,
      loaded: !1,
      opened: !1,
      videoElement: null,
      playing: !1,
      deviceNo: "",
      ctx: null,
      canvas: null,
      mediaRecorder: undefined,
      recordedChunks: [],
    };
  },
  mounted() {
    flvjs.LoggingControl.enableDebug && (flvjs.LoggingControl.enableDebug = !1),
      flvjs.LoggingControl.enableVerbose &&
      (flvjs.LoggingControl.enableVerbose = !1),
      flvjs.LoggingControl.enableInfo && (flvjs.LoggingControl.enableInfo = !1);
  },
  methods: {
    muted() {
      //禁音
      this.isMuted = true;
    },
    voice() {
      //禁音
      this.isMuted = false;
    },

    load(t) {
      var e = this.videoPlayer.src;
      console.log("load video:" + e);
      var s = e.split('/')
      var d = s[s.length - 1];
      var ss = d.split('-')
      this.deviceNo = ss[0]
      if (flvjs.isSupported()) {
        var i = document.querySelector("#" + this.videoPlayer.videoId);
        this.canvas = document.querySelector("#" + this.videoPlayer.canvasId);
        this.ctx = this.canvas.getContext("2d");
        this.videoElement = i;
        // 重置倍速为 1x，防止上次播放的倍速设置残留
        i.playbackRate = 1;
        // 历史回放用 VOD 模式（isLive: false），实时监控用直播模式（isLive: true）
        var isHistoryPlayback = this.videoPlayer.isRealPlay === 1;
        if (this.flvPlayer) {
          // 如果 flvPlayer 已存在（从直播切到回放或反过来），先销毁重建
          this.flvPlayer.detachMediaElement();
          this.flvPlayer.destroy();
          this.flvPlayer = null;
        }
        this.flvPlayer = flvjs.createPlayer(
          {
            type: "flv",
            isLive: !isHistoryPlayback, // 历史回放=false(VOD模式)，实时=true(直播模式)
            url: e,
            // 视频流中禁用音频解码，避免 flv.js MSE 音频编解码兼容性问题导致视频无法播放
            // 音频通过独立的 AudioPlay 组件（音频专用 FLV 流）播放
            hasAudio: !1,//雅迅的视频终端需要禁用，否则会无法播放
            hasVideo: !0,
            cors: !0,
            duration: isHistoryPlayback ? 36e5 : undefined, // VOD模式需要duration参数
            enableStashBuffer: true, // 启用缓存缓冲区
            stashInitialSize: isHistoryPlayback ? 512 * 1024 : 128 * 1024, // 回放模式加大初始缓存
            // 回放模式需要更大的缓冲区来支持快进
            autoCleanupSourceBuffer: !isHistoryPlayback, // VOD模式关闭自动清理
            autoCleanupMaxBackwardDuration: isHistoryPlayback ? 120 : 30, // 回放模式保留更长回溯
            autoCleanupMinBackwardDuration: isHistoryPlayback ? 30 : 10,
          },
          {

            // 网络相关优化
            enableWorker: false, // 禁用WebWorker解码，避免错误
            enableHardwareAcceleration: true, // 启用硬件解码（需浏览器支持）



            statisticsInfoReportInterval: 2e3,
            extLoader: t,
          }
        );
        this.flvPlayer.on(flvjs.Events.ERROR, this._onError);
        this.flvPlayer.on(flvjs.Events.IO_OPENED, this._onOpen);
        this.flvPlayer.on(flvjs.Events.SERVER_MSG_ARRIVED, this._onReceiveMsg);
        this.flvPlayer.on(flvjs.Events.LOADING_COMPLETE, this._onPlayComplete);
        this.flvPlayer.on(flvjs.Events.STATISTICS_INFO, this._onStatisticsInfo);
        this.flvPlayer.on(
          flvjs.Events.METADATA_ARRIVED,
          this._onMetaDataArrived
        );
        this.flvPlayer.on(flvjs.Events.STATISTICS_INFO, (stats) => {
          // console.log('STATISTICS_INFO事件触发:', stats);
          var currentPath = this.deviceNo;
          const startTime = settings.routeStartTime[currentPath]
          if (startTime) {
            // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
            console.log(Date.now());
            const renderTime = Date.now() - startTime
            console.log(`终端 ${currentPath} 渲染耗时：${renderTime}`)
            // 可选：上报到后端或日志系统
            // reportRenderTime(currentPath, renderTime)

            // 清除已计算的开始时间，避免重复计算
            delete settings.routeStartTime[currentPath]
          }

        });
        this.flvPlayer.attachMediaElement(i);
        this.opened = !1;
        this.flvPlayer.load();
        this.loaded = !0;
        setTimeout(this._checkOpenStatus, 5e3);
      } else this.videoPlayer.setPromptWord("notSupport");
    },
    unload() {

      this.loaded = !1;

      if (this.flvPlayer) {
        try {
          this.flvPlayer.pause();
        } catch (e) {
          console.warn("VideoPlay: pause error", e);
        }
        try {
          this.flvPlayer.unload();
        } catch (e) {
          console.warn("VideoPlay: unload error", e);
        }
      }

      this.playing = !1;

      // this.flvPlayer = null;
      // this.flvPlayer=undefined

    },
    getMediaInfo() {
      return this.flvPlayer ? this.flvPlayer.mediaInfo : null;
    },
    destroy() {
      // console.log("destroy video");
      if (this.flvPlayer) {
        try {
          this.unload();
        } catch (e) {
          console.warn("VideoPlay: unload in destroy error", e);
        }
        this.videoElement = null;
        try {
          this.flvPlayer.detachMediaElement();
        } catch (e) {
          console.warn("VideoPlay: detachMediaElement error", e);
        }
        try {
          this.flvPlayer.destroy();
        } catch (e) {
          console.warn("VideoPlay: flvPlayer destroy error", e);
        }
        this.flvPlayer = null;
      }
    },
    _destroy() {
      // console.log("_destroy video");
      this.videoPlayer.VideoPlay
        ? this.videoPlayer.VideoPlay.destroy()
        : this.destroy();
    },
    getCurrentTime() {
      return this.flvPlayer && !0 === this.loaded
        ? this.flvPlayer.currentTime
        : 0;
    },
    setCurrentTime(t) {
      this.flvPlayer && !0 === this.loaded && (this.flvPlayer.currentTime = t);
    },
    getBuffered() {
      return this.flvPlayer && this.loaded ? this.flvPlayer.buffered : null;
    },
    getPlaybackRate() {
      return this.videoElement ? this.videoElement.playbackRate : 1;
    },
    setVolume(volume) {
      if (this.videoElement) {
        this.videoElement.volume = Math.max(0, Math.min(1, volume));
      }
    },
    setPlaybackRate(t) {
      if (this.videoElement) {
        this.videoElement.playbackRate = t;
      }
      // 倍速播放时动态调整缓冲区大小，防止缓冲耗尽导致卡住
      if (this.flvPlayer && this.flvPlayer._mediaDataSource) {
        var isHistoryPlayback = this.videoPlayer.isRealPlay === 1;
        if (isHistoryPlayback) {
          if (t > 1) {
            // 快进时：增大缓冲区上限，减少自动清理，保证数据跟得上消耗
            this.flvPlayer._mediaDataSource.autoCleanupMaxBackwardDuration = 300;
            this.flvPlayer._mediaDataSource.autoCleanupMinBackwardDuration = 60;
            this.flvPlayer._mediaDataSource.stashInitialSize = 1024 * 1024;
          } else {
            // 1x 正常速度：恢复默认缓冲参数
            this.flvPlayer._mediaDataSource.autoCleanupMaxBackwardDuration = 120;
            this.flvPlayer._mediaDataSource.autoCleanupMinBackwardDuration = 30;
            this.flvPlayer._mediaDataSource.stashInitialSize = 512 * 1024;
          }
        }
      }
    },
    getPaused() {
      return !!this.videoElement && this.videoElement.paused;
    },
    pause() {
      this.videoElement && this.videoElement.pause();
    },
    play() {
      this.videoElement && this.videoElement.play();
    },
    isPlaying() {
      return this.playing;
    },
    setDebugMode(t) {
      console.log("video player setDebugMode: ".concat(t)),
        t
          ? (flvjs.LoggingControl.enableAll = !0)
          : (flvjs.LoggingControl.enableDebug &&
            (flvjs.LoggingControl.enableDebug = !1),
            flvjs.LoggingControl.enableVerbose &&
            (flvjs.LoggingControl.enableVerbose = !1),
            flvjs.LoggingControl.enableInfo &&
            (flvjs.LoggingControl.enableInfo = !1));
    },
    startRecord() {
      var mediaInfo = this.videoPlayer.getMediaInfo();
      //   console.log(i);
      if (mediaInfo && mediaInfo.width && mediaInfo.height) {
        this.canvas.width = mediaInfo.width;
        this.canvas.height = mediaInfo.height;
      }
      //定时把video中的内容复制到canvas中
      this.drawFrame(); // 开始绘制

      const canvasStream = this.canvas.captureStream(30); // 25fps

      // 创建音频上下文
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      // 创建媒体源节点
      const mediaSource = audioContext.createMediaElementSource(
        this.videoElement
      );
      // 创建音频流目的地
      const destination = audioContext.createMediaStreamDestination();
      // 将媒体源连接到目的地
      mediaSource.connect(destination);
      // 获取音频流
      const audioStream = destination.stream;

      // 合并音视频流
      const combinedStream = new MediaStream([
        ...canvasStream.getTracks(),
        ...audioStream.getTracks(),
      ]);

      this.mediaRecorder = new MediaRecorder(combinedStream);

      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.recordedChunks.push(event.data);
        }
      };

      this.mediaRecorder.onstop = () => {
        const blob = new Blob(this.recordedChunks, { type: "video/webm" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "recorded_video.webm";
        link.click();
        this.recordedChunks = [];
      };

      this.mediaRecorder.start();
    },
    drawFrame() {
      if (this.ctx) {
        this.ctx.drawImage(
          this.videoElement,
          0,
          0,
          this.canvas.width,
          this.canvas.height
        );
        // 循环调用drawFrame函数，实现视频的连续播放
        requestAnimationFrame(this.drawFrame);
      }
    },
    stopRecord() {
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
        this.mediaRecorder.stop();
      }
    },
    send(t) {
      this.flvPlayer && this.flvPlayer.send(t);
    },
    _checkOpenStatus() {
      // console.log("this.opened", this.opened);
      // console.log("this.playing", this.playing);
      // console.log("this.videoStatus", this.videoPlayer.videoStatus);
      try {
        if (
          (this.opened && this.playing) ||
          2 != this.videoPlayer.videoStatus
        ) {
          console.log("check open status： failed， need reconnect");
          this._reconnect();
        }
        // if ((!this.opened || !this.playing) && 2 == this.videoPlayer.videoStatus) {
        //   console.log("check open status： failed， need reconnect");
        //   this._reconnect();
        // }
      } catch (t) { }
    },
    _onMetaDataArrived(t) {
      this.videoPlayer.setPromptWord("empty");
      this.playing = true;
    },
    _onOpen() {
      //不执行
      console.log("_onOpen");
      this.opened = true;
      this.videoPlayer.onLoaded();
    },
    _onReceiveMsg(t) {
      console.log("receiveMsg:".concat(t));
      this.videoPlayer.onReceiveMsg(t);
    },
    _onError(t, e) {
      if (
        (console.log(
          "["
            .concat(this.videoPlayer.displayName, "] videoplay error,  type:")
            .concat(t, ", ")
            .concat(e)
        ),
          t == flvjs.ErrorTypes.NETWORK_ERROR ||
          (t == flvjs.ErrorTypes.MEDIA_ERROR &&
            e == flvjs.ErrorDetails.MEDIA_MSE_ERROR) ||
          (t == flvjs.ErrorTypes.MEDIA_ERROR &&
            e == flvjs.ErrorDetails.MEDIA_FORMAT_UNSUPPORTED))
      ) {
        this.videoPlayer.flow = "";
        var i = this.videoPlayer.videoStatus;
        1 == i || 2 == i
          ? ((this.videoPlayer.totalTimeStamp = this.videoPlayer.historyTime),
            this.unload(),
            this.reconnectTimeout && clearTimeout(this.reconnectTimeout),
            (this.reconnectTimeout = setTimeout(this._reconnect, 3e3)))
          : setTimeout(this._destroy, 0);
      }
    },
    _onPlayComplete(t) {
      console.log("videoplay event: LoadingCompleted"),
        (this.videoPlayer.flow = "");
      var e = this.videoPlayer.videoStatus;
      1 == e || 2 == e
        ? (this.unload(),
          this.reconnectTimeout && clearTimeout(this.reconnectTimeout),
          (this.reconnectTimeout = setTimeout(this._reconnect, 3e3)))
        : setTimeout(this._destroy, 0);
    },
    _onStatisticsInfo(t) {
      this.videoPlayer.onStatisticsInfo(t);
    },
    _reconnect() {
      console.log("_reconnect");
      this._destroy();
      this.videoPlayer.reconnect();
      this.reconnectTimeout = null;
    },
  },
};
</script>
